// from https://stackoverflow.com/questions/2936112/text-wrap-in-a-canvas-element
function getLines (ctx, text, maxWidth) {
  const words = text.split(' ')
  const lines = []
  let currentLine = words[0]

  for (let i = 1; i < words.length; i++) {
    const word = words[i]
    const width = ctx.measureText(currentLine + ' ' + word).width
    if (width < maxWidth) {
      currentLine += ' ' + word
    } else {
      lines.push(currentLine)
      currentLine = word
    }
  }
  lines.push(currentLine)
  return lines
}

function getLinesWithNewLines (ctx, text, maxWidth) {
  const splitSentence = text.split('\n')
  let output = []

  splitSentence.forEach((item, index) => {
    const lines = getLines(ctx, item, maxWidth)
    output = output.concat(lines)
  })

  return output
}

function getFont (textPosition) {
  switch (textPosition) {
    case 'top':
    case 'bottom':
      return 'Anton'
    case 'above':
    case 'subtitle':
    case 'below':
      return 'Roboto Condensed, sans-serif'
  }
}

function drawTextArea (textArea, ctx, clickCheckCanvas, index) {
  const clickCheck = clickCheckCanvas.getContext('2d')
  clickCheck.fillStyle = 'rgb(' + (index + 1) * 25 + ',0,0)'

  // var ctx = canvasElement.getContext("2d");
  let displayWidth = 460

  const font = getFont(textArea.textPosition)
  let words = textArea.memeText

  ctx.font = textArea.fontSize + 'px ' + font
  switch (textArea.textPosition) {
    case 'top':
    case 'bottom':
      words = textArea.memeText.toUpperCase()
  }

  ctx.textAlign = 'center'
  ctx.fillStyle = 'white'
  ctx.strokeStyle = 'black'
  ctx.lineWidth = 1
  ctx.shadowColor = 'rgba(0,0,0,0.3)'
  ctx.shadowBlur = 2

  if (textArea.textPosition === 'subtitle') {
    ctx.fillStyle = '#f7e948'
    textArea.fontSize = 28
    ctx.shadowOffsetX = 3
    ctx.shadowOffsetY = 3
    ctx.shadowBlur = 4
    displayWidth = 360 // 75% of panel width
    ctx.font = textArea.fontSize + 'px ' + font
  }

  const lines = getLinesWithNewLines(ctx, words, displayWidth)

  lines.forEach((item, index) => {
    const x = 480 / 2
    let y
    switch (textArea.textPosition) {
      case 'bottom':
        y = 350 - (lines.length - index - 1) * (textArea.fontSize + 2)
        break

      case 'top':
        y = textArea.fontSize + 8 + index * (textArea.fontSize + 2)
        break

      case 'subtitle':
        y = 340 - (lines.length - index - 1) * (textArea.fontSize + 2)
        break
    }
    ctx.fillText(item, x, y)
    ctx.strokeText(item, x, y)
    const textSize = ctx.measureText(item)
    clickCheck.fillRect(x - (textSize.width / 2), y - (textArea.fontSize), textSize.width, textArea.fontSize)
  })
}

function drawAboveBelowTextArea (textArea, originalCanvasElement, clickCheckCanvas, index) {
  // setup fonts
  const fontSize = textArea.fontSize
  const font = getFont(textArea.textPosition)

  // create above element
  // needs a dummy size to figure out newline shenanigans
  const newTextElement = document.createElement('canvas')
  newTextElement.width = 480 // height set later
  const newTextContext = newTextElement.getContext('2d')
  const aboveElement = document.createElement('canvas')
  aboveElement.width = 480
  aboveElement.height = 360
  const ctx = aboveElement.getContext('2d')

  // determine the new height and set it
  ctx.font = fontSize + 'px ' + font
  const height = ctx.measureText('M').width
  const lineHeight = height * 1.5
  const lines = getLinesWithNewLines(ctx, textArea.memeText, 460)
  const imageY = Math.floor(lines.length * lineHeight) + Math.floor((lineHeight - height))
  aboveElement.height = imageY + originalCanvasElement.height
  newTextElement.height = aboveElement.height

  // need to do so the "background" color is white
  ctx.fillStyle = 'white'
  ctx.fillRect(0, 0, aboveElement.width, aboveElement.height)

  // lose font after resize, so need to reset
  ctx.font = fontSize + 'px ' + font
  ctx.fillStyle = 'black'

  // set the fontmask fontstyle
  newTextContext.fillStyle = 'rgb(' + (index + 1) * 25 + ',0,0)'

  if (textArea.textPosition === 'above') {
    ctx.drawImage(originalCanvasElement, 0, imageY)
    newTextContext.drawImage(clickCheckCanvas, 0, imageY)

    lines.forEach((item, index) => {
      const x = 10
      const y = (index + 1) * lineHeight
      ctx.fillText(item, x, y)
      const textSize = ctx.measureText(item)
      newTextContext.fillRect(x, y - (textArea.fontSize), textSize.width, textArea.fontSize)
    })
  } else if (textArea.textPosition === 'below') {
    ctx.drawImage(originalCanvasElement, 0, 0)
    newTextContext.drawImage(clickCheckCanvas, 0, 0)

    lines.forEach((item, index) => {
      const x = 10
      const y = originalCanvasElement.height +
                (index + 1) * lineHeight
      ctx.fillText(item, x, y)
      const textSize = ctx.measureText(item)
      newTextContext.fillRect(x, y - (textArea.fontSize), textSize.width, textArea.fontSize)
    })
  }

  // copy canvas
  originalCanvasElement.width = aboveElement.width
  originalCanvasElement.height = aboveElement.height
  originalCanvasElement.getContext('2d').drawImage(aboveElement, 0, 0)

  clickCheckCanvas.width = newTextElement.width
  clickCheckCanvas.height = newTextElement.height
  clickCheckCanvas.getContext('2d').drawImage(newTextElement, 0, 0)
}

export function drawMeme (canvasElement, textAreas, originalCanvasElement, clickCheckCanvas) {
  clickCheckCanvas.width = 480
  clickCheckCanvas.height = 360

  canvasElement.width = 480
  canvasElement.height = 360
  const context = canvasElement.getContext('2d')

  context.drawImage(originalCanvasElement, 0, 0)
  textAreas.forEach((textArea, index) => {
    if (
      textArea.textPosition !== 'above' ||
            textArea.textPosition !== 'below'
    ) {
      drawTextArea(textArea, context, clickCheckCanvas, index)
    }
  })

  // all the aboves get processed last, otherwise text wont be where you expect it
  textAreas.forEach((textArea, index) => {
    if (
      textArea.textPosition === 'above' ||
            textArea.textPosition === 'below'
    ) {
      drawAboveBelowTextArea(
        textArea,
        canvasElement,
        clickCheckCanvas,
        index
      )
    }
  })

  return clickCheckCanvas
}

export function loadImage (baseImageElement, baseImageUrl, callback) {
  // these need to be defined for the BPG decoding to work
  baseImageElement.width = 480
  baseImageElement.height = 360
  try {
    const context = baseImageElement.getContext('2d')
    const img = new BPGDecoder(context)
    img.onload = function () {
      // draw the image to the canvas
      context.putImageData(this.imageData, 0, 0)

      callback()
    }
    img.load(baseImageUrl)
  } catch (e) {
    console.log('there was an error')
    throw e
  }
}

export function moveCanvasToImageElement (canvas, imageElement) {
  // we might need to bring this back and change things by user agent
  // as firefox crashes when long clicking it
  const dataURL = canvas.toDataURL('image/jpeg', 0.9)
  imageElement.src = dataURL
  // canvas.toBlob(
  //     function (blob) {
  //         let url = URL.createObjectURL(blob);
  //         imageElement.src = url;
  //     },
  //     "image/jpeg",
  //     0.9
  // );
}

export function shareMeme (canvasElement) {
  canvasElement.toBlob(
    function (blob) {
      const shareData = { files: [new File([blob], 'test.jpg', { type: 'image/jpeg' })] }
      if (navigator.canShare && navigator.canShare(shareData)) {
        navigator.share(shareData)
          .then(() => console.log('Share was successful.'))
          .catch((error) => console.log('Sharing failed', error))
      } else {
        console.log("Your system doesn't support sharing files.")
      }
    },
    'image/jpeg'
  )
}
